export class saveTransActionBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    clientId: string;
    transactionDate: string;
    clientAuthorizationId: string;
    totalAmount: any;
    payor: string;
    serviceCode: string;
    serviceId: string;
}
export class AuthorizationReturnBO {
    clientAuthorizatonId: string;
    payorId: string;
    payorName: string;
    totalAmount: number;
    remainingAmount: number;
    serviceCode: string;
    startDate: string;
    endDate: string;
    insuranceNumber: string;
    authNote: string;
}


export class GetTransactionBO {
    currentpageno: number = 1;
    pageitem: number = 250;
    orderColumn: string = "client";
    orderType: string = "asc";
    type: string = "";
    field: string = "client";
    operator: string = "startswith";
    value: string = "";
    matchCase: boolean = false;
    startDate: string | null;
    endDate: string | null;
    clientId: string;
    serviceId: string;
}


export class WhereCondition {
    field: string = "client";
    value: string = "";
    operator: string = "startswith";
    matchCase: boolean = false;
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
}
export class functionpermission {
    transactioncreate: boolean = true
    transactionupdate: boolean = true

    transactiondelete: boolean = true

}
